import { createSelector } from '@ngrx/store';
import { IFolderState } from './folder.reducer';
const folderStore = (state: any) => state.folder as IFolderState;
export const selectFolderLista = createSelector(
  folderStore,
  (state) => state.lista
);
